module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Pencils-p-1080-9b44fd5a1126a13cf72927d40f1a85d5.png";